<template>
  <div class="calico-prompt-bubble">
    <div class="prompt-bubble-container body--medium">
      {{ prompt }}
    </div>
    <CalicoFileCard 
      v-for="(attachment, index) in attachments" 
      :key="index" 
      :name="attachment.name"
      :type="attachment.type"
      :size="Math.floor(attachment.size/1024) + 'kb'"
    />
  </div>
</template>

<script>
import CalicoFileCard from "@/components/calico/fileCard/index.vue";

export default {
  name: 'CalicoPromptBubble',
  components: {
    CalicoFileCard
  },
  props: {
    prompt: {
      type: String,
      required: true
    },
    attachments: {
      type: Array,
      required: true,
      default: () => ([])
    },
  },
};
</script>

<style lang="scss">
.calico-prompt-bubble {
  @include stack-space($space-small);
  padding-left: $space-large;
  align-items: flex-end;
  .prompt-bubble-container {
    background-color: $color-background-primary-alt;
    color: $color-text-primary-alt;
    padding: $space-medium;
    border-radius: $radius-medium;
    display: inline-block;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 85%;
  }
}
</style>
